import React, { useMemo } from 'react';

import { EMediaWidth } from '@r1-frontend/ui-react/tokens/mediaWidth';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { COUNT_CAROUSEL_SUB_ITEMS } from '~/src/features/yandex-landing/constants';
import { CarouselStationData, sliderPropsSmartStation } from '~/src/features/yandex-landing/data';
import { getCarouselImgUrl, getIdsForCarouselStation } from '~/src/features/yandex-landing/utils';
import type { TCarouselImgUrl } from '~/src/features/yandex-landing/utils/types';

import * as ST from './styled';

const SmartStationCarousel: React.FC = () => {
    const isTabletOnly = useMatchMedia(EMediaWidth.tabletOnly);
    const isTablet = useMatchMedia(EMediaWidth.tablet);
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktopOnly);

    const {
        backgroundColor,
        titleMain,
        subTextMain,
        imgUrlBaseMain: {
            url,
            type,
        },
        textColor,
        positionText,
        iconUrlBase: {
            typeIcon,
            iconUrl,
        },
        slipText,
    } = CarouselStationData;

    const mediaData = useMemo((): TCarouselImgUrl['mediaData'] => (
        {
            tablet: isTabletOnly,
            sDesktop: isSDesktop,
            mobile: isMobile,
        }
    ), [isTabletOnly, isSDesktop, isMobile]);

    return (
        <ST.ContainerAlisaCarousel>
            <ST.AlisaCarouselTitle as='h2'>{'Яндекс.Станция – \nумная колонка с Алисой'}</ST.AlisaCarouselTitle>
            <ST.AlisaCarousel { ...{ ...sliderPropsSmartStation, showArrows: !isTablet } }>
                {getIdsForCarouselStation().map((id) => (
                    <ST.AlisaCarouselWrapper key={id}>
                        <ST.MainBlockWrapper
                            background={isMobile ? getCarouselImgUrl({ id, url, type, mediaData }) : backgroundColor[id]}
                        >
                            <ST.TextContainer positionText={positionText[id]}>
                                <ST.TextWrap textColor={textColor[id]}>
                                    <ST.TitleMainBlock>{titleMain[id]}</ST.TitleMainBlock>
                                    <ST.SubTextMainBlock>{subTextMain[id]}</ST.SubTextMainBlock>
                                </ST.TextWrap>
                            </ST.TextContainer>
                            {!isMobile && <ST.ImgBlock ImgUrl={getCarouselImgUrl({ id, url, type, mediaData })}/>}
                        </ST.MainBlockWrapper>
                        <ST.TripleCardWrapper>
                            {[...Array(COUNT_CAROUSEL_SUB_ITEMS)].map((_, key) => (
                                <ST.Slip key={id + key}>
                                    <ST.SlipContentWrapper>
                                        <ST.SlipIcon iconUrl={`${iconUrl}${id}${key}${typeIcon}`}/>
                                        <ST.SlipText>{slipText[id][key]}</ST.SlipText>
                                    </ST.SlipContentWrapper>
                                </ST.Slip>
                            ))}
                        </ST.TripleCardWrapper>
                    </ST.AlisaCarouselWrapper>
                ))}
            </ST.AlisaCarousel>
        </ST.ContainerAlisaCarousel>
    );
};

export default SmartStationCarousel;
